import styles from './screen-reader-announcer.module.css';

type ScreenReaderAnnouncerProps = {
  message: string;
  ariaLive: 'polite' | 'assertive';
};

/**
 * A React component that announces messages to screen readers using ARIA live regions.
 *
 * @param message - The message to be announced to screen readers.
 * @param ariaLive - The politeness setting for the aria-live region (e.g., "polite", "assertive").
 *
 * @remarks
 * This component is intended to improve accessibility by providing dynamic updates to assistive technologies.
 */
export function ScreenReaderAnnouncer({
  message,
  ariaLive,
}: ScreenReaderAnnouncerProps) {
  return (
    <div
      aria-live={ariaLive}
      role="status"
      className={styles['screen-reader-announcer']}
    >
      {message}
    </div>
  );
}
